import React, { useState } from "react";
import WaitTransportViz from "../datavisualization/WaitTransportViz";
import UseTransportViz from "../datavisualization/UseTransportViz";
import WalkAloneViz from "../datavisualization/WalkAloneViz";
import "./VizPage.css";
import vizposter from "../pictures/viz.jpg";
import Slogan from "../mapcomponents/Slogan";

function VizPage() {
  const [activeViz, setActiveViz] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);

  const vizTitles = ["Wait for Transport", "Use Transport", "Walk Alone"];

  const toggleZoom = () => {
    setIsZoomed(!isZoomed);
  };

  const handleLeftArrowClick = () => {
    setActiveViz((prevActiveViz) =>
      prevActiveViz === 0 ? vizTitles.length - 1 : prevActiveViz - 1
    );
  };

  const handleRightArrowClick = () => {
    setActiveViz((prevActiveViz) =>
      prevActiveViz === vizTitles.length - 1 ? 0 : prevActiveViz + 1
    );
  };

  const renderActiveViz = () => {
    switch (activeViz) {
      case 0:
        return <WaitTransportViz />;
      case 1:
        return <UseTransportViz />;
      case 2:
        return <WalkAloneViz />;
      default:
        return <WaitTransportViz />;
    }
  };

  return (
    <div className="viz-page-container">
      <Slogan
        main={"Public Transportation Safety: Women Feel More Unsafe Than Men"}
        sub={
          "Explore data showing gender differences in safety perceptions while using public transport and walking alone after dark."
        }
      />

      <div className="poster-container" onClick={toggleZoom}>
        <img
          src={vizposter}
          alt="Safety Survey Poster"
          className={`poster-image ${isZoomed ? "zoomed" : ""}`}
          style={{ cursor: isZoomed ? "zoom-out" : "zoom-in" }}
        />
      </div>

      <div className="viz-navigation-container">
        <div className="left-arrow arrow-button" onClick={handleLeftArrowClick}>
          &#9664;
        </div>

        <div className="viz-card">
          <div className="viz-title">{vizTitles[activeViz]}</div>
          {renderActiveViz()}
        </div>

        <div
          className="right-arrow arrow-button"
          onClick={handleRightArrowClick}
        >
          &#9654;
        </div>
      </div>
    </div>
  );
}

export default VizPage;
